import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container } from "@mui/material";

import FatehLogo from "../Assets/FPS_Logo.png";

import AOS from "aos";
import "aos/dist/aos.css";

export default function Footer() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);

  const footerColumns = [
    {
      title: "Quick Links",
      links: [
        { name: "Home", path: "/" },
        { name: "About Us", path: "/AboutUs?Type=AboutUs" },
        { name: "Academics", path: "/FeeStructure?Type=FeeStructure" },
        { name: "Facilities", path: "/AboutUs#facilities" },
      ],
    },
    {
      title: "Explore",
      links: [
        { name: "Gallery", path: "/ImageGallery?Type=ImageGallery" },
        { name: "Admission", path: "/AdmissionForm?Type=AdmissionForm" },
        { name: "Verify TC", path: "/TcForm?Type=TcForm" },
        { name: "Contact Us", path: "/ContactUs?Type=ContactUs" },
      ],
    },
    {
      title: "Contact Info",
      links: [
        { name: "Baqarganj, Fatehpur, Uttar Pradesh – 212601" },
        { name: "fatehpurpublicschool@gmail.com" },
        { name: "+91 730 785 4518" },
        { name: "MON – SAT: 8AM – 2PM" },
      ],
    },
  ];

  return (
    <>
      <footer className="bg-[#0A1F44] text-white py-8" data-aos="fade-up">
        <Container maxWidth="lg">
          <div className="grid md:grid-cols-4 gap-8">
            <div data-aos="fade-right">
              <div className="flex items-center gap-3 mb-6">
                <div className="bg-white rounded-xl p-2 shadow-md">
                  <img src={FatehLogo} alt="Fatehpur Public School" className="h-12 w-auto object-contain" loading="lazy" />
                </div>
                <div>
                  <h3 className="text-2xl font-semibold leading-tight text-white"><span>Fatehpur</span></h3>
                  <p className="text-sm text-[#D6E4FF]"><span>Public School</span></p>
                </div>
              </div>

              <p className="text-[#D6E4FF] text-sm leading-relaxed">Knowledge Is Power.</p>
              <div className="mt-5 h-[2px] w-20 bg-[#F4B400] rounded-full" />
            </div>

            {footerColumns.map((column, index) => (
              <div key={index} data-aos="fade-up" data-aos-delay={index * 150}>
                <h4 className="text-lg font-bold mb-5 text-[#F4B400]">{column.title}</h4>

                <ul className="space-y-3">
                  {column.links.map((link, i) => (
                    <li key={i}>
                      {link.path ? (
                        <Link to={link.path} className="text-[#D6E4FF] hover:text-[#FFD54F] transition-colors duration-300">
                          {link.name}
                        </Link>
                      ) : (
                        <span className="text-[#D6E4FF]">{link.name}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-[#F4B400]/40 mt-10 pt-6 text-center text-[#D6E4FF]" data-aos="fade-up" data-aos-delay="300">
            <p className="text-sm">
              © {new Date().getFullYear()}{" "}
              <span className="text-white font-semibold">
                Fatehpur Public School
              </span>
              . All rights reserved.
            </p>

            <p className="text-sm mt-2">
              <a href="http://rayaninfosolutions.com" target="_blank" rel="noopener noreferrer" className="text-[#D6E4FF] hover:text-[#FFD54F] transition-colors duration-300">
                Designed by: Rayan Info Solutions
              </a>
            </p>
          </div>
        </Container>
      </footer>

      <div className="fixed bottom-6 right-6 z-[999]" data-aos="zoom-in" data-aos-delay="500">
        <a href="https://wa.me/917307854518?text=Hello%20I%20want%20admission%20details" target="_blank" rel="noopener noreferrer" className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-all duration-300 hover:scale-110 hover:bg-[#1ebe5d]">
          <i className="bi bi-whatsapp text-3xl"></i>
          <span className="absolute right-16 hidden whitespace-nowrap rounded-md bg-black px-3 py-1 text-xs text-white opacity-0 transition group-hover:block group-hover:opacity-100">
            Chat with us
          </span>
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-30"></span>
        </a>
      </div>

    </>
  );
}



